export default {
  'en-US': {
    returnReasons: {
      Restock: 'Restock',
      Hold: 'Hold',
      Dispose: 'Dispose',
      Cancel: 'Cancel',
      Other: 'Other',
      Quarantine: 'Quarantine'
    }
  }
}
